import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7611cc14&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppCampaignBanner: require('/home/runner/work/snooze-vue-storefront/snooze-vue-storefront/components/common/AppCampaignBanner.vue').default})
